import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// ========== SCSS ==========
import '../scss/directory.scss';

// ========== ICONS ==========
import team from '../_assets/images/icons/team.png';
import team_purple from '../_assets/images/icons/team_purple.png';
import docs from '../_assets/images/icons/docs.png';

export class FileItem extends Component {
  constructor(props) {
    super(props);
  }

  async deleteFile() {
    let response = await window.doRequest('POST', {
      action: 'deleteFile',
      id: this.props.id,
      token: sessionStorage.getItem('token')
    });

    if (response.status)
      window.location.reload();
    else
      window.alert(response.message);
  }

  getControllers() {
    return (
      <div className="file-controllers">
        <button
          title="Apagar arquivo..."
          onClick={(e) => {
            e.preventDefault();
            if (window.confirm('Excluir arquivo?')) {
              this.deleteFile();
            }
          }}
        >
          <FontAwesomeIcon icon="fa-solid fa-trash" />
        </button>
      </div>
    );
  }

  getIconByFileName(fileName) {
    let base = window.normalizeString(fileName);

    if (base.includes('interlocutores'))
      return team;
    if (base.includes('equipe'))
      return team_purple;

    return docs;
  }

  getItemByType() {
    // later modification... custom file element
    if (this.props.directory_type != null && this.props.directory_type == 'team') {
      return (
        <div className="team-file-container">
          <a
            className="team-file"
            href={window.utils.site_url + 'uploads/' + this.props.source}
            target="_blank"
            rel="noopener"
          >
            <img className="icon" src={this.getIconByFileName(this.props.name)} />
            <h3>{ this.props.name }</h3>
          </a>
          <div className="team-file-controllers">
            <button
              className="btn grey"
              onClick={(e) => {
                e.preventDefault();
                if (window.confirm('Excluir arquivo?')) {
                  this.deleteFile();
                }
              }}
            >
              Apagar arquivo...
            </button>
          </div>
        </div>
      );
    }

    let defaultE = <a
                    href={window.utils.site_url + 'uploads/' + this.props.source}
                    className="item"
                    target="_blank"
                    rel="noopener"
                  >
                    <h3>{ this.props.name }</h3>
                    { this.getControllers() }
                  </a>;

    // block photo view in NO gallery directory
    if (this.props.directory_type != 'gallery' && this.props.type == 'photo')
      return defaultE;

    switch (this.props.type) {
      case 'photo':
        return (
          <div className="photo-container">
            <img
              src={window.utils.site_url + 'uploads/' + this.props.source}
              onClick={(e) => {
                if (document.querySelector('#galleryContainer')) {
                  document.querySelector('#galleryContainer').classList.add('active');
                  document.querySelector('#galleryContainer img').setAttribute('src', e.target.getAttribute('src'));
                }
              }}
            />
            <h3>{ this.props.name }</h3>
            { this.getControllers() }
          </div>
        );
      case 'vimeo':
        let videoId = /[^/]*$/.exec(this.props.source)[0];
        return (
          <div className="video-container">
            <iframe src={'https://player.vimeo.com/video/' + videoId} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen={true}></iframe>
            <h3>{ this.props.name }</h3>
          </div>
        );
      case 'youtube':
        let source = new URL(this.props.source);
        let youtubeId = source.searchParams.get('v');
        return (
          <div className="video-container">
            <iframe src={'https://www.youtube.com/embed/' + youtubeId} title={this.props.name} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
            <h3>{ this.props.name }</h3>
          </div>
        );
      case 'onedrive':
      case 'embed_video':
        // verify if is firefox
        if (this.props.source.includes('onedrive') && !(typeof InstallTrigger !== 'undefined')) {
          return (
            <div className="video-container">
              <div className="embed-video"/>
              <div className="iframe-error">
                <p>Não é possível exibir vídeos incorporados do OneDrive!</p>
              </div>
              <h3>{ this.props.name }</h3>
              { this.getControllers() }
            </div>
          );
        }

        return (
          <div className="video-container">
            <div className="onedrive-video" dangerouslySetInnerHTML={{ __html: this.props.source }} />
            <h3>{ this.props.name }</h3>
            { this.getControllers() }
          </div>
        );
      case 'wp_page':
        return (
          <div className="wp-post-container">
            <h3>{ this.props.name }</h3>
            <div className="post-content" dangerouslySetInnerHTML={{ __html: this.props.rendered }} />
            <a
              className="btn filled"
              href={this.props.source}
              target="_blank"
              rel="noopener"
            >
              Editar...
            </a>
          </div>
        );
      default:
        return defaultE;
    }
  }

  render() {
    return this.getItemByType();
  }
}

export default FileItem
